// import { basicUrl, domainUsername, domainPassword } from './config/config.js';



export default async function getToken() {

    const domainUsername = process.env.REACT_APP_DOMAIN_USERNAME;
const domainPassword = process.env.REACT_APP_DOMAIN_PASSWORD;
const basicUrl = process.env.REACT_APP_BASIC_URL;

// console.log('domainUsername:', domainUsername)
// console.log('domainPassword:', domainPassword)

    const tokenResponse = await fetch(`${basicUrl}/wp-json/jwt-auth/v1/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: domainUsername,
        password: domainPassword
      })
    });
  
    // const tokenData = await tokenResponse.json();
        const tokenData =  await tokenResponse.json()
    // console.log('tokenData:', tokenData)

  
    if (!tokenData || !tokenData.data || !tokenData.data.token) {
      throw new Error('Failed to retrieve token');
    }
    // console.log('Token:', tokenData.data.token)
    return tokenData.data.token;
  }
  
